import React from 'react'
import PropTypes from 'prop-types'
import { useLocalization } from '@contexts/LocalizationContext'
import { message } from 'antd'
import FormComponent from './Form'
import { client } from '@utils/client'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import Modal from '@components/Modal'

const Edit = (props) => {
  const { setModalEditOpen, modalEditOpen, defaultValues } = props
  const { t } = useLocalization()
  const history = useHistory()
  // const params = useParams()

  const handleSubmit = async (data) => {
    data.startDate = data.usableSinceToUntil[0].format('YYYY-MM-DD')
    data.endDate = data.usableSinceToUntil[1].format('YYYY-MM-DD')

    let id = data.id
    delete data.id // ลบ ID เนื่องจาก Put ใช้ส่งทั้ง Form Backend ไม่รับ
    delete data.usableSinceToUntil
    try {
      await client.patch(`/discount-codes/${id}`, data)
      setModalEditOpen(false)
      message.success('สำเร็จ')
      history.push('/discount-code')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  //เเปลงวันที่กลับเป็น moment ก่อนเสดงข้อมูลที่ Field
  defaultValues.usableSinceToUntil = [
    moment(defaultValues.startDate),
    moment(defaultValues.endDate),
  ]
  //delete defaultValues.totalQuantity
  //delete defaultValues.usedQuantity

  return (
    <>
      <Modal
        centered={true}
        title={t('discountCode.list.edit')}
        open={modalEditOpen}
        onCancel={() => setModalEditOpen(false)}
        maskClosable={false}
        footer={null}
      >
        <FormComponent
          isEdit
          handleSubmit={handleSubmit}
          doStatus="edit"
          defaultValues={defaultValues}
        />
      </Modal>
    </>
  )
}

Edit.propTypes = {
  defaultValues: PropTypes.object,
  setModalEditOpen: PropTypes.func,
  modalEditOpen: PropTypes.bool,
}

export default Edit
